import React, { useMemo } from 'react'
import { Modal, Progress, Typography } from 'antd'
import { CheckCircleFilled } from '@ant-design/icons'
import { useIntl } from 'react-intl'
import classNames from 'classnames'

import IndeterminateProgress from 'components/UI/IndeterminateProgress'
import styles from './AppConnectProgressModal.module.scss'

const { Title, Text } = Typography

const CrmIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.65122 19.3851C4.05611 18.5327 3.58524 17.6077 3.23554 16.6102C3.14965 16.3662 3.07296 16.1222 3.0024 15.8767C-0.858142 15.7701 -1.2692 7.51491 3.37971 7.85927C3.85212 6.65789 4.51318 5.56615 5.35983 4.5856C6.29851 3.50158 7.47493 2.6322 8.89215 1.97901C10.3094 1.32737 11.9551 1 13.8309 1C15.4276 1 16.7942 1.20074 17.9323 1.60378C19.0688 2.00526 20.0167 2.52257 20.7759 3.15568C21.5336 3.7888 22.1379 4.46206 22.5858 5.17548C23.0352 5.88889 23.3742 6.56215 23.6042 7.19372C23.7806 7.6786 24.2208 8.6329 23.865 9.08226C23.7269 9.25676 23.5368 9.34941 23.3159 9.34941H18.986C18.6746 9.34941 18.4108 9.15484 18.3173 8.85681C18.216 8.53717 18.0182 8.16347 17.7222 7.73728C17.4231 7.30491 16.9629 6.92967 16.3448 6.60693C15.7267 6.28574 14.9077 6.12515 13.8908 6.12515C12.6944 6.12515 11.6913 6.4309 10.883 7.04394C10.0747 7.65698 9.47192 8.44451 9.0716 9.40963C8.67282 10.3747 8.47342 11.3785 8.47342 12.4239C8.47342 13.4693 8.67282 14.473 9.0716 15.4381C9.14983 15.6265 9.23572 15.8087 9.32928 15.9848C9.58235 16.4573 9.46425 17.0333 9.04553 17.3668L8.02556 18.1806C9.34001 19.4623 11.0609 20.4289 12.9061 20.7934C13.1607 20.3733 13.6193 20.0923 14.1392 20.0923H16.2758C17.0703 20.0923 17.7191 20.7455 17.7191 21.5469C17.7191 22.3484 17.0703 23 16.2758 23H14.1392C13.5089 23 12.9705 22.5892 12.7742 22.0194C10.771 21.8789 8.8538 20.8659 7.02093 18.982L6.22029 19.6198C5.97642 19.8143 5.6942 19.8916 5.38591 19.8452C5.07762 19.8004 4.82914 19.646 4.64969 19.3882L4.65122 19.3851Z"
      fill="currentColor"
    />
  </svg>
)

const GajiHubIcon = () => (
  <svg width="32" height="32" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.188 6.79161C14.311 6.10643 12.7945 6.09672 10.9257 7.43339L9.96471 8.11856L7.6808 9.75385L5.99298 7.90387C5.78968 7.68833 5.50981 7.56132 5.21373 7.55021C4.91764 7.5391 4.62905 7.64479 4.41017 7.8445C4.19129 8.0442 4.05966 8.32192 4.04364 8.61778C4.02763 8.91364 4.12853 9.20395 4.32458 9.42611L6.68843 12.0161C6.87483 12.2201 7.12951 12.3487 7.40433 12.3776C7.67915 12.4066 7.95504 12.3338 8.17983 12.1731C8.17983 12.1731 12.7756 8.45658 12.8008 8.43774C13.4026 7.92386 13.981 7.70746 14.7838 7.89874C15.4341 8.05404 15.9663 8.58962 15.976 9.12292C16.1319 8.15853 15.8315 7.29521 15.188 6.79161Z"
      fill="currentColor"
    />
    <path
      d="M14.8362 8.72269C14.6649 8.66559 14.0169 8.4646 13.2238 9.13665L11.5679 10.4739L12.6008 10.0862C12.6971 10.0503 12.8017 10.0435 12.9017 10.0665C13.0018 10.0896 13.0929 10.1416 13.1637 10.2159C13.2345 10.2903 13.2819 10.3839 13.3 10.4849C13.318 10.586 13.3061 10.6902 13.2655 10.7845C12.7775 11.9094 11.9424 12.8487 10.8825 13.4651C9.82248 14.0814 8.59312 14.3426 7.3741 14.2104C4.73218 13.93 2.58929 11.8008 2.29239 9.16006C2.15433 7.98216 2.38495 6.79043 2.95248 5.74908C3.52001 4.70772 4.39652 3.868 5.46123 3.3456C6.52594 2.8232 7.72645 2.64385 8.89736 2.83224C10.0683 3.02064 11.1519 3.56751 11.999 4.39752C12.1037 4.50437 12.2286 4.58937 12.3664 4.6476C12.5042 4.70582 12.6521 4.73611 12.8017 4.7367C12.9513 4.73729 13.0995 4.70818 13.2378 4.65105C13.376 4.59392 13.5015 4.50991 13.6071 4.40389C13.7126 4.29787 13.796 4.17196 13.8525 4.03345C13.909 3.89494 13.9374 3.74659 13.9361 3.59701C13.9348 3.44743 13.9039 3.2996 13.845 3.16208C13.7861 3.02457 13.7005 2.90011 13.5932 2.79592C12.772 1.98595 11.7848 1.36385 10.6997 0.972588C9.61465 0.581326 8.45759 0.43022 7.30844 0.529703C3.40465 0.858587 0.269405 4.06121 0.0170317 7.97242C-0.282732 12.6213 3.41379 16.5 7.9999 16.5C9.42539 16.4993 10.8248 16.1179 12.0535 15.3952C13.2822 14.6724 14.2955 13.6346 14.9887 12.3889C15.1314 12.1465 15.2554 11.8936 15.3598 11.6324C15.84 10.3528 15.8212 9.051 14.8362 8.72269Z"
      fill="currentColor"
    />
  </svg>
)

const AppConnectProgressModal = ({ open, variant = 'crm', phase, statusMessage }) => {
  const { formatMessage } = useIntl()
  const isSuccess = phase === 'success'
  const isProcessing = phase === 'requesting' || phase === 'processing'
  const isHr = variant === 'hr'

  const title = useMemo(() => {
    if (isSuccess) {
      return formatMessage({ id: 'appConnect.success_title' })
    }
    return formatMessage({
      id: isHr ? 'appConnect.hr.processing_title' : 'appConnect.crm.processing_title',
    })
  }, [formatMessage, isHr, isSuccess])

  const subtitle = useMemo(() => {
    if (isSuccess) {
      return formatMessage({ id: 'appConnect.success_subtitle' })
    }
    if (statusMessage) {
      return statusMessage
    }
    return formatMessage({
      id: isHr ? 'appConnect.hr.processing_subtitle' : 'appConnect.crm.processing_subtitle',
    })
  }, [formatMessage, isHr, isSuccess, statusMessage])

  const icon = useMemo(() => {
    if (isSuccess) {
      return <CheckCircleFilled className={styles.successIcon} />
    }
    return isHr ? <GajiHubIcon /> : <CrmIcon />
  }, [isHr, isSuccess])

  const indeterminateColor = isHr ? '#f472b6' : '#1d4ed8'

  return (
    <Modal
      open={open}
      centered
      closable={false}
      maskClosable={false}
      footer={null}
      destroyOnHidden
      width={400}
      className={styles.modal}
    >
      <div className={styles.content}>
        <div
          className={classNames(styles.iconWrap, {
            [styles.iconPulse]: isProcessing,
            [styles.iconPulseHr]: isProcessing && isHr,
            [styles.iconSuccess]: isSuccess,
            [styles.iconHr]: isHr && !isSuccess,
            [styles.iconCrm]: !isHr && !isSuccess,
          })}
        >
          {icon}
        </div>

        <Title level={4} className={styles.title}>
          {title}
        </Title>
        <Text type="secondary" className={styles.subtitle}>
          {subtitle}
        </Text>

        {isSuccess ? (
          <Progress percent={100} status="success" showInfo={false} className={styles.progress} />
        ) : (
          <IndeterminateProgress
            height={8}
            color={indeterminateColor}
            className={styles.progress}
          />
        )}
      </div>
    </Modal>
  )
}

export default AppConnectProgressModal
